<template>
  <div class="submit-container" v-if="start">
    <p>Submit selected replacement funds to production</p>
    <div class="submit-actions">
      <button class="mds-button" type="button" @click="closeModal">
        Cancel
      </button>
      <mds-button variation="primary" class="submit-button" @click="doSubmit"> Submit to Production </mds-button>
    </div>
  </div>
  <div class="submit-container progress" v-else>
    <loader-spinner />
    <p class="submit-process-text">Submitting to Production</p>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import LoaderSpinner from '@/components/atoms/LoadingSpinner';
import { submitPendingProductFiduFundsReplacementV2 } from '@/services/SelectReplacement';

export default {
  name: 'submit-replacements-new',
  components: {
    LoaderSpinner,
  },
  methods: {
    ...mapActions({
      closeModal: 'closeModal',
    }),
    doSubmit() {
      this.start = false;
      const payload = this.data;
      /* eslint-disable-next-line max-len */
      submitPendingProductFiduFundsReplacementV2({
        fiduciaryNumber: this.fiduciaryNumber,
        payload,
      }).then((result) => {
        this.closeModal();
        if (result.status.success) {
          // force the grid to reload
          this.$store.dispatch('setReloadNeed', true);
          this.$store.dispatch('openNotification', {
            title: 'Updates Successfully Submitted',
            message: `${this.fundsNumber} replacements have been submitted to production`,
          });
        }
      }).catch((error) => {
        const httpStatus = (error?.response.status) ? (error?.response.status) : (error?.status);
        if (httpStatus === 401) {
          this.$router.push('/Login');
        }
      });
    },
  },
  computed: {
    ...mapState({
      fiduciaryNumber: (state) => state.user.fiduciary.id,
    }),
    fundsNumber() {
      return this.data.length;
    },
  },
  data() {
    return {
      start: true,
    };
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>
<style lang="scss">
.submit-container {
  @include mds-body-text-m();
  .submit-process-text {
    text-align: center;
  }
}
</style>
